export default {
  presenter: 'hambalek',
  title: 'Ako si porozumieť keď sme spolu, no každý v inom vesmíre?',
  subtitle: 'Kroky k úspechu',
  text: `
V stručnej prezentácii predstavím úrovne porozumenia medzi ľuďmi a roviny devalvácie. Na príkladoch vysvetlím prečo pri výchove nestačí efektívna komunikácia a čo ešte potrebujeme, aby sme mali silu prežiť sa navzájom a spolupracovať.

Vychovávateľ, sociálny pracovník, lektor tvorivej dramatiky, tréner a kouč manažmentu, koncentratívno-pohybový psychoterapeut, manželský poradca a mediátor, supervízor a budúci transakčný analytik :) Hral som sa a tvoril s deťmi a adolescentmi s poruchami správania, sprevádzal som školské triedy a mnohoproblemové rodiny s rizikovou mládežou v bratislavskej Pedagogicko-psychologickej poradni, učil som, koučoval a facilitoval som zmeny a rozvoj ľudí na rôznych pozíciách v priemysle aj v službách, učil som a supervidoval psychológov v bývalých manželských poradniach a iné pomahajúce profesie v rezortoch školstva, sociálnych vecí a rodiny.
  `,
}



// WEBPACK FOOTER //
// ./src/content/vychovakzivotu/data/presentations/p02_kroky_k_uspechu.js